import React from "react";
import { Form, Input, Button, Card, Typography } from "antd";
import { PlusOutlined, DeleteOutlined, TeamOutlined } from "@ant-design/icons";
import { defaultTeam } from "./defaults";
import type { SectionMeta } from "./types";

const { Text } = Typography;

export const meta: SectionMeta = {
  key: "team",
  label: "Team Members",
  icon: <TeamOutlined />,
  color: "#3b82f6",
  desc: "Leadership team and key personnel",
};

export const defaultData = defaultTeam;

export const Preview: React.FC<{ data: any[] }> = ({ data }) => {
  if (data.length === 0) return null;
  return (
    <div className="space-y-1">
      {data.slice(0, 4).map((item: any, i: number) => (
        <div
          key={i}
          className="flex items-center gap-2 text-sm px-2 py-1 rounded hover:bg-gray-50 transition-colors"
        >
          <div className="w-7 h-7 rounded-full bg-blue-100 text-blue-600 flex items-center justify-center text-xs font-semibold shrink-0">
            {item.name.charAt(0)}
          </div>
          <div className="min-w-0 flex-1">
            <span className="font-medium text-gray-800">{item.name}</span>
            <Text type="secondary" className="text-xs ml-1">
              — {item.role}
            </Text>
          </div>
        </div>
      ))}
      {data.length > 4 && (
        <Text type="secondary" className="text-xs block px-2">
          +{data.length - 4} more members
        </Text>
      )}
    </div>
  );
};

export const FormFields: React.FC = () => (
  <Form.List name="team">
    {(fields, { add, remove }) => (
      <>
        {fields.map((field) => (
          <Card
            key={field.key}
            className="!mb-3"
            size="small"
            type="inner"
            extra={
              <Button
                type="text"
                danger
                size="small"
                onClick={() => remove(field.name)}
                icon={<DeleteOutlined />}
              />
            }
          >
            <div className="grid grid-cols-3 gap-3">
              <Form.Item
                {...field}
                name={[field.name, "name"]}
                label="Full Name"
                className="!mb-0"
                rules={[{ required: true, message: "Required" }]}
              >
                <Input placeholder="e.g. Sarah Fernando" />
              </Form.Item>
              <Form.Item
                {...field}
                name={[field.name, "role"]}
                label="Role / Title"
                className="!mb-0"
                rules={[{ required: true, message: "Required" }]}
              >
                <Input placeholder="e.g. Founder & CEO" />
              </Form.Item>
              <Form.Item
                {...field}
                name={[field.name, "bio"]}
                label="Short Bio"
                className="!mb-0"
                rules={[{ required: true, message: "Required" }]}
              >
                <Input.TextArea
                  rows={2}
                  placeholder="e.g. 15+ years in retail"
                />
              </Form.Item>
            </div>
          </Card>
        ))}
        <Button
          type="dashed"
          block
          onClick={() => add()}
          icon={<PlusOutlined />}
          className="!mb-1"
        >
          Add Team Member
        </Button>
      </>
    )}
  </Form.List>
);
